import { useTaskPermissions } from "../../views/tasks/TaskPermissionsContext";
import {
  ButtonContainer,
  StyledPrimaryButton,
  StyledSecondaryButton
} from "./styles";
import type { FormButtonProps } from "./types";

/**
 * Renders a form button group.
 * @component
 * @param {Object} props - The component props.
 * - handleComplete - The function to handle the complete button click.
 * - handleSave - The function to handle the save button click.
 * - disabled - Indicates if the buttons should be disabled.
 * - labelPrimary - The label for the primary button.
 * - labelSecondary - The label for the secondary button.
 * @returns {JSX.Element} The rendered component.
 */
export const FormButtons = (props: FormButtonProps) => {
  const { canAct, canSave } = useTaskPermissions();
  return (
    <ButtonContainer>
      <StyledPrimaryButton
        disabled={props.disabled || props?.disablePrimary || !canAct}
        onClick={props.handleComplete}
      >
        {props.labelPrimary ?? "Complete"}
      </StyledPrimaryButton>
      {props.handleEvaluateCredit && (
        <StyledPrimaryButton
          onClick={props.handleEvaluateCredit}
          disabled={props.disabled || props?.disableEvaluateCredit || !canAct}
        >
          {props.labelEvaluateCredit ?? "Evaluate credit"}
        </StyledPrimaryButton>
      )}
      {props.handleSave && (
        <StyledSecondaryButton
          onClick={props.handleSave}
          disabled={props.disabled || props?.disableSecondary || !canSave}
        >
          {props.labelSecondary ?? "Save and close"}
        </StyledSecondaryButton>
      )}
    </ButtonContainer>
  );
};
